import { createEvent } from 'effector';
import { TStateStoreReducer } from '../../models';

type TPayload = {
  limit: number;
};
type TReducer = TStateStoreReducer<TPayload>;

export const changePagingLimitEvent = createEvent<TPayload>();
export const changePagingLimitReducer: TReducer = (state, { limit }) => ({
  ...state,
  paging: {
    offset: 0,
    limit,
  },
});
